/**
 * The colour each spendable resource wears, wherever it is shown.
 *
 * These are the three bars' own inner glows (see PlayerRPGBars/*StatBar.vue),
 * lifted out so the cost printed in a caption and the slice marked on a bar are
 * literally the same value. That agreement is what lets a player read "12" in
 * cyan and know which bar it comes out of without a legend naming it.
 */
export type ResourceTone = 'health' | 'flow' | 'actionPoints';

export const RESOURCE_RGB: Record<ResourceTone, string> = {
  health: '255, 76, 76',
  flow: '22, 234, 255',
  actionPoints: '111, 251, 111',
};

/** Refusal red, for a price the character cannot pay. */
export const RESOURCE_SHORT_RGB = '255, 92, 92';

/**
 * The server's cost kinds (`AttributeType` in apps/core/models/core.py) mapped
 * onto the bar each one drains, in the order the bars are stacked.
 */
export const RESOURCE_BY_COST_KIND: {kind: string; tone: ResourceTone}[] = [
  {kind: 'Action Points', tone: 'actionPoints'},
  {kind: 'Energy', tone: 'flow'},
  {kind: 'Health', tone: 'health'},
];
